import { GameShowWheelDial } from "./GameShowWheelDial";
import { GameShowWheelEditor } from "./GameShowWheelEditor";
import { Disc3 } from "lucide-react";

export function GameShowWheelPanel({ show, isHost }) {
  return (
    <div className="panel-wood rounded-2xl p-5 space-y-2" data-testid="gameshow-wheel-panel">
      <h2 className="font-display text-xl flex items-center gap-2"><Disc3 className="w-4 h-4 text-[#3F9142]" /> The Wheel</h2>
      <GameShowWheelDial show={show} isHost={isHost} />
      {isHost && <GameShowWheelEditor show={show} />}
    </div>
  );
}
